import { useEffect, useState } from "react";
import styles from "./EditCleaners.module.css";
import stepOne from "../../../assets/stepone.png";
import stepTwo from "../../../assets/stepTwo.png";
import checkBox from "../../../assets/stepperFilledBox.png";
import box from "../../../assets/stepperBox.png";
import { AntdInput, AntdSubmit } from "../../../components";
import { List, TimePicker } from "antd";
import Item from "antd/es/list/Item";
import { MdCheckBox } from "react-icons/md";
import CleanerMiddleware from "../../../store/Middlewares/CleanerMiddleware";
import AlertAction from "../../../store/Actions/AlertActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-number-input/input";
import CategoriesMiddleware from "../../../store/Middlewares/CategoriesMiddleware";
import moment from "moment";
import InputField from "../../../components/input/InputField";
import AutoCompleteAddress from "../../../components/AutoCompleteAddress/AutoCompleteAddress";

const EditCleaners = () => {

  const { state } = useLocation()
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [FullName, setFullName] = useState(state?.first_name);
  const [LastName, setLastName] = useState(state?.last_name);
  const [Email, setEmail] = useState(state?.email);
  const [ContactNumber, setContactNumber] = useState(state?.contact_no);
  const [Address, setAddress] = useState(state?.address?.[0]);
  const category = useSelector((state) => state.CategoriesReducer.CategoryList)
  const [SelectedCategory, setSelectedCategory] = useState(state?.category_name);
  const [SelectedCategoryID, setSelectedCategoryID] = useState(state?.category_id);
  const [StartTimeModal, setStartTimeModal] = useState(false)
  const [EndTimeModal, setEndTimeModal] = useState(false)
  const [date, setDate] = useState(new Date());
  const [StartTime, setStartTime] = useState(state?.working_start_time);
  const [EndTime, setEndTime] = useState(state?.working_end_time);
  const [BreakIn, setBreakIn] = useState(state?.break_time_in);
  const [BreakOut, setBreakOut] = useState(state?.break_time_out);

  const [search, setSearch] = useState('')

  console.log('state==================================', state);

  useEffect(() => {
    getLanguage();
    getCategories();
  }, []);

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };

  const getCategories = () => {
    dispatch(CategoriesMiddleware.getCategories())
  }


  const onPressEditCleaner = () => {

    //////////////////////////
    let startTime = StartTime
      ? moment(StartTime, 'h:mm:ss A').format('HH:mm:ss')
      : null;
    let endTime = EndTime
      ? moment(EndTime, 'h:mm:ss A').format('HH:mm:ss')
      : null;

    let breakIn = BreakIn
      ? moment(BreakIn, 'h:mm:ss A').format('HH:mm:ss')
      : null;
    let breakOut = BreakOut
      ? moment(BreakOut, 'h:mm:ss A').format('HH:mm:ss')
      : null;
    ////////////////////////////////////


    if (!FullName || !LastName || !Email || !ContactNumber || !Address || !SelectedCategoryID || !StartTime || !EndTime) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: t('All field are required!') }))
      // Alert.alert('Note', t('All field are required!'))
    }
    else if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(Email) == false) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: t('Email format is not valid..') }))

      // Alert.alert("Note", t("Email format is not valid.."))
    } else if (startTime >= endTime) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: t('Start time should be before End time!') }))
    } else if (breakIn >= breakOut) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: t('Break in time should be before Break out time!') }))
    } else if (
      breakIn < startTime ||
      breakOut > endTime
    ) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: t('Break in and Break out time should be between Start and End time!') }))
    }
    else {
      let data = {
        ID: state?.id,
        Firstname: FullName,
        Lastname: LastName,
        Email: Email,
        ContactNumber: ContactNumber,
        AddressID: state?.address[0]?.id,
        Address: Address?.address,
        lat: Address?.lat,
        lng: Address?.lng,
        SelectedCategoryID: SelectedCategoryID,
        StartTime: StartTime,
        EndTime: EndTime,
        BreakIn: BreakIn,
        BreakOut: BreakOut,
        next_page_url: undefined,
        search: search
      }

      dispatch(CleanerMiddleware.cleanersEdit(data))
        .then((data) => {
          console.log('====', data)
          if (data?.success) {
            dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
            navigate(-1)
            // Alert.alert('Note', data?.message, [
            //   { text: 'OK', onPress: () => navigation.goBack() },
            // ]);
          }
          else {
            if (data?.message == 'You have to buy membership first') {
              dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))
              navigate('/subscription')

              // Alert.alert('Note', data?.message, [
              //   { text: 'OK', onPress: () => navigation.navigate('Subscription') },
              // ]);
            }
            else {
              dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))

              // Alert.alert('Note', data?.message)
            }
          }
        })
        .catch((error) => console.log(error))

    }
  }


  const onSelectLocation = (place) => {
    let currentLocation = {
      lat: place?.geometry?.location?.lat(),
      lng: place?.geometry?.location?.lng(),
      address: place?.formatted_address
    }
    setAddress(currentLocation)
  }


  const next = () => {
    if (!FullName || !LastName || !Email || !ContactNumber || !Address) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: t('All field are required!') }))
      // Alert.alert('Note', t('All field are required!'))
    } else {
      setCurrent(current + 1);
    }
  };
  const prev = () => {
    setCurrent(current - 1);
  };
  const options = [
    {
      id: 1,
      category: 'Custodial Engineer',

    },
    {
      id: 2,
      category: 'Flooring',

    },
    {
      id: 3,
      category: 'Maintenance Technician',

    },
    {
      id: 4,
      category: 'Self Contractor Custodial Engineer',

    },
    {
      id: 5,
      category: 'Maintenance Self Contractor',

    },
    {
      id: 6,
      category: 'Custodial and Maintenance Engineer',

    },
    {
      id: 7,
      category: 'Custodial and Maintenance Engineer (Supervisor)',

    },
  ];

  const [selectedItem, setSelectedItem] = useState(options[0]?.id);
  const renderItem = (item) => {
    return (
      <div className={styles.checkBoxItem}>
        <img onClick={() => {
          setSelectedCategory(item?.name)
          setSelectedCategoryID(item?.id)
        }} src={item?.name == SelectedCategory ? checkBox : box} />
        <span>{item?.name}</span>
      </div>
    )
  }
  return (
    <div className={styles.mainDiv}>
      <div className={styles.heading}>
        <h1>Edit Cleaners</h1>
        <div className={styles.imgDiv}>
          {current == "0" ? (
            <img src={stepOne} />
          ) : current == "1" ? (
            <img src={stepTwo} />
          ) : null}
        </div>
      </div>
      <div className={styles.content}>
        {current == "0" ? (
          <div className={styles.form}>
            <div className={styles.row}>
              <div className={styles.col}>
                {/* <AntdInput
                  placeholder={FullName}
                  name={"first_name"}
                  label="First Name"
                  value={FullName}
                  onChange={(e) => setFullName(e.target.value)}
                  rules={[
                    {
                      require: true,
                      type: "text",
                      message: "Please enter a first name",
                    },
                  ]}
                /> */}
                <InputField
                  label={t("First Name")}
                  placeholder={t("First Name")}
                  value={FullName}
                  onChange={(e) => setFullName(e.target.value)}
                  width='100%'
                />
              </div>
              <div className={styles.col}>
                <InputField
                  label={t("Last Name")}
                  placeholder={t("Last Name")}
                  value={LastName}
                  width='100%'
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.col}>

                <InputField
                  label={t("Email")}
                  placeholder={t("Email")}
                  value={Email}
                  width='100%'
                  disabled={true}
                // onChange={(e) => setAddress(e.target.value)}
                />
                {/* <AntdInput
                  placeholder={Email}
                  disabled={true}
                  name={"Email Address"}
                  label="Email Address"
                  onChange={(e) => setEmail(e.target.value)}
                  rules={[
                    {
                      require: true,
                      type: "email",
                      message: "Please enter a email",
                    },
                    {
                      pattern: /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,20}$/,
                      message: "Enter Valid Email",
                    }
                  ]}
                /> */}
              </div>
              <div className={styles.col}>
                <div className={styles.phoneInput}>
                  <label>Contact Number</label>
                  <PhoneInput
                    className={styles.PhoneNumber}
                    placeholder={ContactNumber}
                    defaultCountry="US"
                    value={ContactNumber}
                    maxLength={16}
                    onChange={setContactNumber}
                  />
                </div>
                {/* <AntdInput
                  placeholder={"Contact Number"}
                  name={"contact_number"}
                  label="Contact Number"
                  onChange={(e) => setContactNumber(e.target.value)}
                  rules={[
                    {
                      require: true,
                      type: "text",
                      message: "Please enter a contact number",
                    },
                  ]}
                /> */}
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.col}>
                {/* <InputField
                  label={t("Address")}
                  placeholder={t("Address")}
                  value={Address}
                  width='100%'
                  onChange={(e) => setAddress(e.target.value)}
                /> */}
                <AutoCompleteAddress address={Address?.address} label={'Address'} onSelectLocation={onSelectLocation} placeholder={'Enter Cleaner Address'} />

                {/* <AntdInput
                  placeholder={Address}
                  name={"address"}
                  label="Address"
                  onChange={(e) => setAddress(e.target.value)}
                  rules={[
                    {
                      require: true,
                      type: "text",
                      message: "Please enter a address",
                    },
                  ]}
                /> */}
              </div>
              <div className={styles.col}></div>
            </div>
            {/* <div className={styles.row}>
              <div className={styles.col}>
                <InputField
                  label={t("State")}
                  placeholder={t("State")}
                  value={State}
                  width='100%'
                  onChange={(e) => setState(e.target.value)}
                />
                {/* <AntdInput
                  placeholder={State}
                  name={"state"}
                  label="State"
                  onChange={(e) => setState(e.target.value)}
                  rules={[
                    {
                      require: true,
                      type: "text",
                      message: "Please enter a state",
                    },
                  ]}
                />
              </div>
              <div className={styles.col}>
                <InputField
                  label={t("Zip Code")}
                  placeholder={t("Zip Code")}
                  value={ZipCode}
                  width='100%'
                  onChange={(e) => setZipCode(e.target.value)}
                />
                {/* <AntdInput
                  placeholder={ZipCode}
                  name={"zip_code"}
                  label="Zip Code"
                  onChange={(e) => setZipCode(e.target.value)}
                  rules={[
                    {
                      require: true,
                      type: "text",
                      message: "Please enter a zip code",
                    },
                  ]}
                /> 
              </div>
            </div> */}
            <div className={styles.btn}>
              <AntdSubmit
                onClick={() => next()}
                text={"Next"}
                buttonStyle={{
                  margin: "15px 0px",
                  height: "60px",
                  width: "100%",
                }}
              />
            </div>
          </div>
        ) : current == "1" ? (
          <div className={styles.form}>
            <h3>Categories</h3>
            <List
              className={styles.checkBox}
              style={{ width: "100%" }}
              grid={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 2, xxl: 2 }}
              dataSource={category}
              renderItem={renderItem}
            />
            <h3>Work Hours</h3>
            <div className={styles.timeDiv}>
              <div className={styles.row}>
                <div className={styles.col}>
                  <TimePicker
                    use12Hours
                    format="h:mm a"
                    className={'datePicker'}
                    placeholder={moment(StartTime, ["HH.mm"]).format("hh:mm a")}
                    onChange={(time, timeString) => setStartTime(moment(timeString, ["hh:mm a"]).format("HH:mm:ss"))}
                  />

                </div>
                <div className={styles.col}>
                  <TimePicker use12Hours
                    format="h:mm a" className={'datePicker'} placeholder={moment(EndTime, ["hh:mm a"]).format("hh:mm a")} onChange={(time, timeString) => setEndTime(moment(timeString, ["hh:mm a"]).format("HH:mm:ss"))} />
                </div>
              </div>
              <h3 className={styles.breakHead}>Break Hours</h3>
              <div className={`${styles.row} ${styles.timeRow}`}>
                <div className={styles.col}>
                  <TimePicker
                    use12Hours
                    format="h:mm a"
                    className={'datePicker'}
                    placeholder={moment(BreakIn, ["hh:mm a"]).format("hh:mm a")}
                    onChange={(time, timeString) => setBreakIn(moment(timeString, ["hh:mm a"]).format("HH:mm:ss"))}
                  />

                </div>
                <div className={styles.col}>
                  <TimePicker use12Hours
                    format="h:mm a" className={'datePicker'} placeholder={moment(BreakOut, ["HH.mm"]).format("hh:mm a")} onChange={(time, timeString) => setBreakOut(moment(timeString, ["hh:mm a"]).format("HH:mm:ss"))} />
                </div>
              </div>
              <div className={styles.addbtn}>
                <AntdSubmit
                  onClick={() => onPressEditCleaner()}
                  text={"Update Cleaner"}
                  buttonStyle={{
                    margin: "15px 0px",
                    height: "60px",
                    width: "100%",
                  }}
                />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default EditCleaners;
